import { render, staticRenderFns } from "./covid-19.vue?vue&type=template&id=224cd857&"
import script from "./covid-19.vue?vue&type=script&lang=js&"
export * from "./covid-19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports